import React, { useState } from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import Container from '@material-ui/core/Container';
import Dashboard from './Dashboard';
import Parameters from './parameter/Parameters';
import TherapeuticCategoryList from './therapeuticCategory/TherapeuticCategoryList';
import TherapeuticArea from './therapeuticArea/TherapeuticArea';
import Header from './Header';
import MainMenu from './MainMenu';
import Loader from './loader/Loader';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import './App.css';

function App() {
  const [isDrawerOpen, toggleDrawer] = useState(false);

  return (
    <React.Fragment>
      <CssBaseline />
      <Container maxWidth="lg">
        <Loader />
        <Router>
          <MainMenu isDrawerOpen={isDrawerOpen} toggleDrawer={toggleDrawer} />
          <Header isDrawerOpen={isDrawerOpen} toggleDrawer={toggleDrawer} />
          <Route path="/" exact>
            <Dashboard />
          </Route>
          <Route path="/parameters">
            <Parameters />
          </Route>
          <Route path="/therapeuticArea">
            <TherapeuticCategoryList />
          </Route>
          <Route path="/therapeuticCategory/:id">
            <TherapeuticArea />
          </Route>
        </Router>
      </Container>
    </React.Fragment>
  );
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js